var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textareafield"},[_c('label',{class:this.value && _vm.titleLabel == undefined
        ? 'textareafield__label filled'
        : 'textareafield__label',attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.phName))]),_c('textarea',{staticClass:"textareafield__input",attrs:{"id":_vm.name,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }